/* src/app/components/controls/sem-hidden-value/sem-hidden-value.component.css */
.sem-hidden-value-button {
  background-color: #007bff;
  color: white;
  border: 1px solid #007bff;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-family: inherit;
  transition: background-color 0.2s ease;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  display: block;
  position: absolute;
  top: 20px;
}
.sem-hidden-value-button:hover:not(:disabled) {
  background-color: #0056b3;
  border-color: #0056b3;
}
.sem-hidden-value-button:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}
.sem-hidden-value-button:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}
.sem-hidden-value-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
  padding: 8px 0;
}
.loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.sem-hidden-value-error {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #dc3545;
  font-size: 14px;
  padding: 8px 0;
}
.sem-hidden-value-unauthorized {
  display: flex;
  align-items: center;
  color: #ffc107;
  font-size: 14px;
  padding: 8px 0;
  font-weight: 500;
}
.retry-button {
  background-color: #dc3545;
  color: white;
  border: 1px solid #dc3545;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  align-self: flex-start;
  transition: background-color 0.2s ease;
}
.retry-button:hover:not(:disabled) {
  background-color: #c82333;
  border-color: #c82333;
}
.retry-button:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}
.sem-hidden-value-display {
  display: flex;
  flex-direction: column;
}
.readonly-value {
  background-color: #f8f9fa !important;
  cursor: default !important;
  border-color: #dee2e6 !important;
}
.readonly-value:focus {
  box-shadow: none !important;
  border-color: #dee2e6 !important;
}
.disabled-field {
  opacity: 0.6;
  cursor: not-allowed !important;
}
.binding-prop-name {
  font-size: 10px;
  color: #6c757d;
  margin: 4px 0 0 0;
  font-family: monospace;
}
.sem-text-box {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  line-height: 1.5;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.sem-text-box:focus {
  outline: 0;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.is-invalid {
  border-color: #dc3545;
}
.inline-search-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  cursor: pointer;
}
.hidden-value-input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}
.hidden-input-with-icon {
  padding-right: 35px !important;
}
.reveal-icon-btn-inside {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #666;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 15;
}
.reveal-icon-btn-inside:hover {
  color: #333;
}
.reveal-icon-btn-inside mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.copy-btn:hover {
  color: #007bff;
}
/*# sourceMappingURL=sem-hidden-value.component.css.map */
